import React, { useState } from "react";
import * as Dfns from "date-fns/fp";
import { Router, RouteComponentProps } from "@reach/router";
import { Page, DatePicker } from "../Components";
import { useTabbedNav } from "../utils/hooks/useNav";
import StyleGuide from "./StyleGuide";
import Generate from "./Generate";
import Dashboard from "./Dashboard";
import "./Copytiger.scss";
import Train from "./Train";
import { TODAY } from "@blisspointmedia/bpm-types/dist/RelativeDatePicker";
import { DateRange } from "../utils/types";
import * as R from "ramda";
const enum PageTab {
  STYLEGUIDE = "style-guide",
  GENERATE = "generate",
  DASHBOARD = "dashboard",
  TRAIN = "train",
}

const NAVS = [
  { label: "Train Model", key: PageTab.TRAIN },
  { label: "Style Guide", key: PageTab.STYLEGUIDE },
  { label: "Generate", key: PageTab.GENERATE },
  { label: "Dashboard", key: PageTab.DASHBOARD },
];

export default React.memo(({ navigate }: RouteComponentProps) => {
  const defaultKey = NAVS[0].key;
  const { tab, goToTab } = useTabbedNav({
    baseURL: "copytiger",
    defaultKey,
    navigate,
    navs: R.map(R.prop("key"), NAVS),
  });
  const defaultStartDate = Dfns.format("yyyy-MM-dd")(Dfns.subMonths(4, new Date()));
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    start: defaultStartDate,
    end: TODAY,
  });
  return (
    <Page
      app2Redesign
      pageType="Copytiger"
      title="Copytiger"
      navs={NAVS}
      selectedNav={tab}
      onNav={goToTab}
      actions={
        tab === PageTab.TRAIN ? (
          <div className="copytigerActionsWrapper">
            <DatePicker range={selectedDateRange} onChange={setSelectedDateRange} maxDate={TODAY} />
          </div>
        ) : null
      }
    >
      <Router primary={false} style={{ width: "100%", height: "100%" }}>
        <Train path="/train" start={selectedDateRange.start} end={selectedDateRange.end} />
        <StyleGuide path="/style-guide" />
        <Generate path="/generate" onHide={() => {}} />
        <Dashboard path="/dashboard" />
      </Router>
    </Page>
  );
});
